export default  {
  resetState: ({ commit }) => commit('resetState'),
  getItem ({ commit, dispatch }, options){
     dispatch('request', {type: 'relation.item', options: options, next: function (response) {
          if (options.next) return options.next(response)
          commit('setRelation', response )
     }}, {root: true} )
  },
  getRelation ({ commit, dispatch }, options){
     dispatch('request', {type: 'relation.item', options: options, next: function (response) {
          if (options.next) return options.next(response)
          commit('setRelation', response )
     }}, {root: true} )
  },
  addContact ({ commit, dispatch }, options){
    console.log(options)
     dispatch('request', {type: 'contact.add', options: options, next: function (response) {
       console.log(response)
          if (options.next) options.next(response)
     }}, {root: true} )
  },
  save ({ commit, dispatch }, options){
     dispatch('request', {type: 'relation.save', options: options, next: function (response) {
          if (options.next) options.next(response)
     }}, {root: true} )
  },
  updateRelation ({ commit, dispatch }, options){
     dispatch('request', {type: 'relation.save', options: options, next: function (response) {
          if (options.next) options.next(response)
     }}, {root: true} )
  },
  load ({ commit, dispatch }, options){
     dispatch('request', {type: 'relation.list', options: options, next: function (response, count) {
          commit('setList', response )
          if (options.next) options.next(response)
     }}, {root: true} )
  },
   getContactName ({ commit, dispatch }, options) {
                var name = options.name
                if (!name) return options.next({})
                var gender = 'unknown'
                if (name.indexOf('Dhr.')>-1) gender = 'male'
                if (name.indexOf('Mw.')>-1) gender = 'female'
                name = name.replace('Dhr. ','').replace('Mw. ','')
                var sname = name
                var names = sname.split(' ');
                var initials,first,middle,last
                if (names.length == 1) { 
                    last = names[0];
                } else {
                    if (names[0].indexOf('.') > -1) {
                        initials = names[0].toUpperCase();
                    } else {
                        first = names[0].initCap();
                        initials = names[0].substring(0, 1).toUpperCase() + '.';
                    }
                    if (names.length > 2) {
                    middle = '';
                    for (var i = 1; i < names.length - 1; i++) {
                        middle += names[i] + " ";
                    }
                middle = middle.toLowerCase();
                }
                last = names[names.length - 1].initCap();
            }
          options.next({
                initials: initials,
                first_name: first,
                middle_name: middle, 
                last_name : last,
                gender : gender
        })
   }
}